import React from 'react';

// styles
import './styles.scss';

const InStoreOnly = () => {
  return (
    <div id="instore-only">
      <h1>AVAILABLE IN-STORE ONLY</h1>
      <div className="flex">
        <div className="left">
          <h2>SEVENSTORE</h2>
          <p>Baltic Triangle</p>
          <p>Liverpool</p>
          <p>L1 0BE</p>
        </div>
        <div className="right">
          <h2>Opening Times</h2>
          <p>Mon-Sat 10am - 6pm</p>
          <p>Sun 11am - 5pm</p>
          <p>Bank Hol 10am - 4pm</p>
        </div>
      </div>

      <a
        href="https://maps.app.goo.gl/DKcRjyqXYjxoTUNr5"
        target="_blank"
        rel="noreferrer"
        className="get-directions"
      >
        GET DIRECTIONS
      </a>
    </div>
  );
};

export default InStoreOnly;
